import { Topic } from "api/types";
import { ReactComponent as AnimalIcon } from "assets/icons/animal.svg";
import { ReactComponent as BoneIcon } from "assets/icons/bone.svg";
import { ReactComponent as PhysicsIcon } from "assets/icons/chemistry.svg";
import { ReactComponent as DnaIcon } from "assets/icons/dna.svg";
import { ReactComponent as InventionIcon } from "assets/icons/invention.svg";
import { ReactComponent as LeafIcon } from "assets/icons/leaf.svg";
import { ReactComponent as LightningIcon } from "assets/icons/lightning.svg";
import { ReactComponent as MathIcon } from "assets/icons/math.svg";
import { ReactComponent as MedicineIcon } from "assets/icons/medicine.svg";
import { ReactComponent as RocketIcon } from "assets/icons/rocket.svg";

export interface DisplayTopic {
	name: Topic;
	icon: JSX.Element;
	className: string;
}

export const Topics: DisplayTopic[] = [
	{
		name: "Animals",
		icon: <AnimalIcon className="tagIcon" />,
		className: "animalTag",
	},
	{
		name: "Dinosaurs and Fossils",
		icon: <BoneIcon className="tagIcon" />,
		className: "paleontologyTag",
	},
	{
		name: "Environment & Nature",
		icon: <LeafIcon className="tagIcon" />,
		className: "environmentTag",
	},
	{
		name: "Life & Evolution",
		icon: <DnaIcon className="tagIcon" />,
		className: "evolutionTag",
	},
	{
		name: "Medicine & Health",
		icon: <MedicineIcon className="tagIcon" />,
		className: "medicineTag",
	},
	{
		name: "Inventions",
		icon: <InventionIcon className="tagIcon" />,
		className: "inventionTag",
	},
	{
		name: "Mathematics",
		icon: <MathIcon className="tagIcon" />,
		className: "mathsTag",
	},
	{
		name: "Physics",
		icon: <PhysicsIcon className="tagIcon" />,
		className: "physicsTag",
	},
	{
		name: "Space",
		icon: <RocketIcon className="tagIcon" />,
		className: "spaceTag",
	},
	{
		name: "Weather",
		icon: <LightningIcon className="tagIcon" />,
		className: "weatherTag",
	},
];

// Convert Topics to an object for fast lookup
export type TopicMap = {
	[key in Topic]: DisplayTopic;
};

export const topicsMap = Topics.reduce((acc, topic) => {
	acc[topic.name] = topic;
	return acc;
}, {} as TopicMap);
